<!-- <app-navbar></app-navbar>
<hr>
<router-outlet></router-outlet>
<app-footer></app-footer> -->
<router-outlet></router-outlet>